module.exports = __webpack_public_path__ + "img/Ellipse4.149be398.png";